// Maria, 19 October 2026: on a phone the top bar buttons (Help Centre, Ask Felicity) show only their icon, so the top
// bar fits; from 600px wide they look as before
export const PHONE_ICON_ONLY_SX = {
    minWidth: {xs: 36, sm: 64},
    px: {xs: 1, sm: 1.25},
    '& .MuiButton-startIcon': {mr: {xs: 0, sm: 1}, ml: {xs: 0, sm: -0.5}}
};
